import React from 'react';
import MDContentOpenWith from 'ps-react-mkd/MDContentOpenWith';

export default function MDContentExplorerExample () {
    return <MDContentOpenWith fileId={0} token={'4NFvfIajj5SChgMtsBYMsIGeZqm9fN2w'} />
}